export default __webpack_public_path__ + "static/media/bg-halopagi-2-a.5d8a26dc.png";